export default __webpack_public_path__ + "static/media/connections-small.b500131b.svg";